<template>
  <div>
    <h2 class="title is-4 mt-5 has-text-success">
      Raspoloživo godišnjeg odmora:
    </h2>

    <!-- Table -->

    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: false,
      }"
      @on-row-dblclick="rowDoubleclicked"
      @on-row-click="rowClicked"
    >
      <template slot="table-row" slot-scope="props">
        <span
          v-if="
            props.column.field !== 'before' &&
            props.index == rowToEditIndex &&
            props.column.editable
          "
        >
          <validation-provider
            :rules="pravila(props.column.field)"
            v-slot="{ errors }"
          >
            <input
              class="input has-background-warning has-text-centered"
              v-model="props.row[props.column.field]"
              type="text"
              @keyup.enter="saveRowToBackend(props.row)"
            />
            <span class="has-text-danger">{{ errors[0] }}</span>
          </validation-provider>
        </span>
        <span v-if="props.column.field === 'before'">
          <!-- edit icon -->
          <span
            v-if="props.index !== rowToEditIndex"
            class="icon has-text-info"
          >
            <i
              class="fas fa-edit"
              v-if="props.row.isnew === false"
              @click="editRow(props)"
            >
              <font-awesome-icon icon="edit" />
            </i>
          </span>
          <!-- delete icon -->
          <span
            v-if="props.index !== rowToEditIndex"
            class="icon has-text-danger"
          >
            <i
              class="fas fa-trash-alt"
              v-if="props.row.isnew === false"
              @click="deleteRow(props.row)"
            >
              <font-awesome-icon icon="trash-alt" />
            </i>
          </span>
          <!-- cancel edit icon -->
          <span
            v-if="props.index === rowToEditIndex"
            class="icon has-text-danger"
          >
            <i class="fas fa-ban" @click="cancelEditRow(props.row)">
              <font-awesome-icon icon="ban" />
            </i>
          </span>
          <!-- save icon -->
          <span
            v-if="props.index === rowToEditIndex"
            class="icon has-text-primary"
          >
            <i class="fas fa-save" @click="saveRowToBackend(props.row)">
              <font-awesome-icon icon="save" />
            </i>
          </span>
          <!-- add new row button -->
          <button
            class="button is-info is-size-7"
            v-if="props.row.isnew === true && props.index !== rowToEditIndex"
            @click="addRow(props.row)"
          >
            Dodaj
          </button>
        </span>
        <span v-else>
          <div v-if="props.index !== rowToEditIndex || !props.column.editable">
            {{ props.formattedRow[props.column.field] }}
          </div>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import "vue-select/dist/vue-select.css";
import { VueGoodTable } from "vue-good-table";
import reportService from "../../services/report.service";

import { ValidationProvider, extend } from "vee-validate";
import { required, integer } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Ovo polje je obavezno",
});

extend("integer", {
  ...integer,
  message: "Polje mora biti cio broj",
});

extend("positive", (value) => {
  return value >= 0;
});

export default {
  components: {
    VueGoodTable,
    ValidationProvider,
  },

  name: "DayoffsQuantity",

  props: {
    employeeId: Number,
  },

  data() {
    return {
      rowToEditIndex: -1,
      columns: [
        {
          label: "Godina",
          field: "year",
          type: "number",
          sortable: false,
          editable: true,
          width: "120px",
        },
        {
          label: "Raspoloživo dana",
          field: "days",
          sortable: false,
          editable: true,
        },
        {
          label: "Komentar",
          field: "comment",
          sortable: false,
          editable: true,
        },
        {
          label: "Akcije",
          field: "before",
          sortable: false,
          width: "90px",
        },
      ],
      rows: [],
      oldRows: [],
    };
  },

  async mounted() {
    console.log(this.employeeId);
    await this.getData(this.employeeId);
  },

  methods: {
    async getData(id) {
      this.rows = [];
      var responseData = (
        await reportService.GetDaysoffQuantityByEmployeeId(id)
      ).data;
      console.log("response data:");
      console.log(responseData);

      responseData.forEach((rd) => {
        this.rows.push({
          correspondingId: rd.id,
          year: rd.year.split("-")[0],
          days: rd.quantity,
          comment: rd.comment,
          isnew: false,
        });
      });

      // add "add" row
      this.rows.push({
        isnew: true,
      });
    },

    editRow(props) {
      console.log(props);
      this.saveRows();

      this.rowToEditIndex = props.row.originalIndex;
      console.log(this.rowToEditIndex);
    },

    async deleteRow(dqInput) {
      let text = "Izbrisati stavku?";
      if (confirm(text) == true) {
        text = "You pressed OK!";
      } else {
        text = "You canceled!";
        return;
      }

      const dqToDelete = {
        daysoffQuantityId: dqInput.correspondingId,
      };

      const { message } = (
        await reportService.DeleteDayoffsQuantity(dqToDelete)
      ).data;

      if (message !== "Success") {
        alert(message);
        this.cancelEditRow();
      }

      await this.getData(this.employeeId);
    },

    cancelEditRow() {
      this.revertRows();
    },

    addRow(row) {
      console.log(row);

      this.saveRows();
      this.rowToEditIndex = row.originalIndex;

      // Use Array.reduce() to find the object with the latest year
      const latestYearRow = this.rows.reduce((latest, current) => {
        // Convert years to numbers for comparison
        const latestYear = parseInt(latest.year);
        const currentYear = parseInt(current.year);

        // Compare years and update if current year is greater
        if (currentYear > latestYear) {
          return current;
        } else {
          return latest;
        }
      });

      row.year =
        latestYearRow.year === undefined
          ? "2022"
          : String(parseInt(latestYearRow.year) + 1);
    },

    saveRows() {
      this.oldRows = [];
      this.rows.forEach((row) => {
        this.oldRows.push(row);
      });
    },

    revertRows() {
      this.rowToEditIndex = -1;
      this.rows = this.oldRows;
    },

    rowDoubleclicked(props) {
      if (props.row.isnew) {
        this.addRow(props.row);
      } else {
        console.log(props);
        this.editRow(props);
      }
    },

    rowClicked(props) {
      if (
        this.rowToEditIndex > -1 &&
        props.row.originalIndex !== this.rowToEditIndex
      ) {
        this.cancelEditRow();
      }
    },

    async saveRowToBackend(dqInput) {
      console.log(dqInput);

      const dayofQuantityToSend = {
        daysoffQuantityId: dqInput.correspondingId,
        employeeId: this.employeeId,
        quantity: dqInput.days,
        comment: dqInput.comment,
        year: dqInput.year + "-01-01T00:00:00",
      };

      if (!this.validateSendObject(dayofQuantityToSend)) {
        alert("Unijeti podaci nisu validni!");
        this.revertRows();
        return;
      }

      console.log("sending quantity", dayofQuantityToSend);

      let text = "Sačuvati stavku?";
      if (confirm(text) == true) {
        text = "You pressed OK!";
      } else {
        text = "You canceled!";
        this.revertRows();
        return;
      }

      if (!dqInput.isnew) {
        const { message, dq } = (
          await reportService.EditDaysoffQuantity(dayofQuantityToSend)
        ).data;
        this.processResult(message, dq);
      } else {
        const { message, dq } = (
          await reportService.CreateDayoffsQuantity(dayofQuantityToSend)
        ).data;
        this.processResult(message, dq);

        // relod rows
        await this.getData(this.employeeId);
      }

      if (text === "You pressed OK!") {
        this.$emit("updateEmployeeId", this.employeeId);
        console.log("emited updateEmployeeId");
      }
    },

    async processResult(message, dq) {
      console.log(message);
      console.log(dq);

      if (message !== "Success") {
        alert(message);
        this.cancelEditRow();
      } else {
        // unselect the row
        this.rowToEditIndex = -1;
      }
    },

    validateSendObject(obj) {
      if (typeof obj.quantity !== "number" && isNaN(Number(obj.quantity)))
        return false;
      return true;
    },

    pravila(props) {
      switch (props) {
        case "days":
          return "integer";
        case "year":
          return "integer";
        default:
          return null;
      }
    },
  },
};
</script>
